module.exports = __webpack_public_path__ + "static/media/autopilot-mode@2x.6ab656e9.png";